import { Card, BlockStack, Text } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { AddressPicker } from "@shared/ui";
import { Venue, GeoAddress } from "@features/events/types";

interface LocationCardProps {
  venueData: Partial<Venue>;
  fieldErrors: Record<string, string>;
  onDataChange: (updates: Partial<Venue>) => void;
}

export default function LocationCard({
  venueData,
  fieldErrors,
  onDataChange,
}: LocationCardProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <BlockStack gap="400">
        <Text as="h2" variant="headingMd">
          {t('venues.details.section.address')}
        </Text>

        <AddressPicker
          value={venueData.geoAddress || null}
          onChange={(geoAddress: GeoAddress | null) => {
            onDataChange({
              geoAddress: geoAddress || undefined,
            });
          }}
          error={fieldErrors.geoAddress}
          requiredIndicator
        />
      </BlockStack>
    </Card>
  );
}

